import config from './config.json';

export const usdFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  trailingZeroDisplay: 'stripIfInteger'
});

export const calculatePrice = (render, span, background, nsfw, count) => {
  let calcPrice = config.pricesAndNotes[render].price[span === 'Half Body' ? 'half' : 'full'];

  if (nsfw) {
    calcPrice += calcPrice * config.pricesAndNotes['NSFW'].price;
  }
  if (render === 'VTuber Model') {
    calcPrice += (count - 1) * 100;
  } else {
    calcPrice += calcPrice * 0.5 * (count - 1);
  }

  if (background) {
    const backgroundLow = config.pricesAndNotes['Background'].price[0];
    const backgroundHigh = config.pricesAndNotes['Background'].price[1];
    return `${usdFormat.format(calcPrice + backgroundLow)}-${usdFormat.format(
      calcPrice + backgroundHigh
    )}`;
  } else {
    return usdFormat.format(calcPrice);
  }
};

export const getCommissionStatus = () => {
  if (config.sketchOpen || config.fullRenderOpen || config.vtuberOpen) {
    if (config.slotsOpen === config.slotsFilled) {
      return 'full';
    }

    let res = 'open';
    if (config.sketchOpen) {
      res += 'sketch';
    }
    if (config.fullRenderOpen) {
      res += 'fullrender';
    }
    if (config.vtuberOpen) {
      res += 'vtuber';
    }
    if (
      (config.sketchOpen && !config.fullRenderOpen && !config.vtuberOpen) ||
      (config.sketchOpen && !config.fullRenderOpen && !config.vtuberOpen) ||
      (!config.sketchOpen && !config.fullRenderOpen && config.vtuberOpen)
    ) {
      res += 'only';
    }
    return res;
  }
  return 'closed';
};
